(ns quuppa.peweb.peinfo
  (:require [clojure.string :as str]
            [goog.string :as gstring]
            [goog.string.format]
            ["@js-joda/core" :as js-joda :refer [Temporal]]
            [komponentit.timeago :as timeago]
            [reagent.core :as r]
            ["react" :as react]
            [re-frame.core :as rf]
            [shadow.lazy :as lazy]
            [quuppa.components :as c :refer [info-button]]
            [quuppa.date-time.core :as date-time]
            [quuppa.utils :as utils :refer [format-bytes]]
            [quuppa.ui.button :as button]
            [quuppa.ui.icons :refer [icon]]
            [quuppa.ui.spinner :refer [spinner]]
            [quuppa.ui.layout :as layout]
            [quuppa.ui.alert-popover  :refer [alert-popover]]
            [quuppa.peweb.connection :as connection]
            [quuppa.peweb.outputs :as outputs]
            [quuppa.peweb.peinfo-events]
            [quuppa.peweb.peinfo-locators :as locators]
            [quuppa.peweb.peinfo-logs :as peinfo-logs]
            [quuppa.peweb.peinfo-tags :as tags]
            [quuppa.peweb.universalformat.universal-target :as peweb-ut]
            [quuppa.ui.form :as form]))

;; TODO: Idea for qpe-dispatch/subscribe.
;; We could store the QPE identity on React Context, and define these functions globally.
;; There is just a few limitations for reading Context using useContext Hook, e.g. inside event handlers,
;; so that would need to be solved first.

;; TODO Remove or rewrite this as it shows whether siteplan key exists in Customer Portal,
;; Instead we should show subscriptions linked to the selected siteplan
(defn license-details [license {:keys [close-fn]}]
  [layout/sidebar
   {:class-name "sidebar license-details-sidebar"}
   [layout/sidebar-header
    {:on-close #(close-fn)
     :title    "License details"}]

   [layout/sidebar-content
    [:table.table-sm.table-striped.table-bordered.w-100
     [:tbody
      [:tr.bg-dark.text-white
       [:th "License property"]
       [:th "Value"]]
      [:tr
       [:th {:scope "row"} "UUID"]
       [:td (:id license)]]
      [:tr
       [:th {:scope "row"} "Start date"]
       [:td (date-time/format-date-time (:startDate license))]]
      [:tr
       [:th {:scope "row"} "Expiration date"]
       [:td (date-time/format-date-time (:expirationDate license))]]
      [:tr
       [:th {:scope "row"} "Push and Log module expiration date"]
       [:td (date-time/format-date-time (:pushAndLogExpirationDate license))]]
      [:tr
       [:th {:scope "row"} "Back Channel module expiration date"]
       [:td (date-time/format-date-time (:backChannelExpirationDate license))]]
      [:tr
       [:th {:scope "row"} "Trial period expiration date"]
       [:td (date-time/format-date-time (:deploymentExpirationDate license))]]
      ;[:tr
      ; [:th {:scope "row"} "AOD module expiration date"]
      ; [:td "7e3d1715-a9d5-406b-a7f0-b003ad5431ba"]]
      [:tr
       [:th {:scope "row"} "License type"]
       [:td (:licenseType license)]]
      [:tr
       [:th {:scope "row"} "Is perpetual?"]
       [:td (:isPerpetual license)]]
      [:tr
       [:th {:scope "row"} "License type override"]
       [:td "Not implemented"]]
      [:tr
       [:th {:scope "row"} "Max number of followed Tags"]
       [:td (:maxNumFollowedTags license)]]
      [:tr
       [:th {:scope "row"} "Max offline time interval (hours)"]
       [:td (:maxOfflineTimeIntervalHours license)]]
      [:tr
       [:th {:scope "row"} "Max number of Locators allowed"]
       [:td (:maxNumLocators license)]]
      [:tr
       [:th {:scope "row"} "Additional notes"]
       [:td (:notes license)]]
      [:tr
       [:th {:scope "row"} "Version"]
       [:td (:version license)]]
      (when (:subscriptions license)
        [:tr
         [:th {:scope "row"} "Subscriptions"]
         [:td
          (for [subscription (:subscriptions license)]
            ^{:key subscription} [:<> subscription [:br]])]])]]]])

(defn select-binary-log-mode [{:keys [qpe-dispatch qpe-subscribe]}]
  [:div.form-group
   [:label.fw-bold
    "Advanced options"]
   [:div.form-group
    [:label.lead.mt-2
     [:input.mr-2
      {:type "checkbox"
       :checked (boolean @(qpe-subscribe [:qpe/data :controller-ui :new-project :binary-log-mode]))
       :on-change #(qpe-dispatch [:qpe/assoc-in [:controller-ui :new-project :binary-log-mode] (.. % -target -checked)])}]
     "Enable binary log mode"]]])

(defn existing-project-row
  [{:keys [qpe-dispatch]} row]
  [:div.card.mt-2
   [:div.card-body.p-2.d-flex.flex-row.align-items-center
    [:div.mr-2
     [:a.btn.btn-outline-primary
      ; stretched-link
      {:on-click #(qpe-dispatch [:qpe/select-existing-project row])}
      "Select"]]
    [:div.col-auto.mr-auto
     [:h5.card-title.mb-1
      (or (:name row) "-")
      [:span.text-muted.ml-2 "(" (:type row) ")"]]
     [:p.card-text.mb-1 [:small (:key row)]]]

    [:div.col-auto
     [:button.btn.btn-outline-danger
      {:title         "Remove project"
       :on-click        #(qpe-dispatch [:qpe/remove-existing-project (:key row)])}
      [icon :trash-fill]]]]])

(defn select-existing-project [{:keys [qpe-subscribe] :as props}]
  [:div

   [:div.mb-2
    (for [[id row] (sort-by (comp :name val) @(qpe-subscribe [:qpe/data :existing-projects]))]
      ^{:key id}
      [existing-project-row props row])]

   [:div.p-2
    [select-binary-log-mode props]]])

(defn select-project-key [{:keys [qpe-subscribe qpe-dispatch] :as props}]
  (let [new-project @(qpe-subscribe [:qpe/data :controller-ui :new-project])]
    [:div.p-2
     [:div.form-group
      [:label.fw-bold
       {:for "project-key"}
       "Key for a submitted project"]
      [c/input-text
       {:attr {:id "project-key"}
        :value (:license-key new-project)
        :on-change #(qpe-dispatch [:qpe/assoc-in [:controller-ui :new-project :license-key] %])}]]

     [:div.form-group
      [:label.fw-bold
       {:for "project-password"}
       "Project password if any"]
      [c/input-text
       {:attr {:id "project-password"}
        :value (:license-password new-project)
        :on-change #(qpe-dispatch [:qpe/assoc-in [:controller-ui :new-project :license-password] %])}]]

     [select-binary-log-mode props]

     [:div.form-group.d-flex.flex-row.justify-content-between
      [:button.btn.btn-outline-primary
       {:on-click #(do (qpe-dispatch [:project-ui/open-license-dialog false])
                       (qpe-dispatch [:qpe/close-sidebar]))}
       "Cancel"]

      [:button.btn.btn-primary
       {:on-click #(qpe-dispatch [:qpe/select-project])}
       "Select project"]]]))

(defn filelist->vec [l]
  (mapv (fn [i]
          (.item l i))
        (range (.-length l))))

(defn upload-project [{:keys [qpe-dispatch qpe-subscribe] :as _props}]
  (let [drop-active? (r/atom nil)
        input-ref (react/createRef)
        select-files (fn [files]
                       (qpe-dispatch [:qpe/assoc-in [:controller-ui :new-project :files] files]))]
    ;; Files aren't uploaded right after selecting using dialog or dropping,
    ;; they are stored to app-db,
    ;; and sent to QPE once clicking on "Upload project" button.
    ;; This is to allow user to set "advanced options" (binary log mode),
    ;; after selecting the files, and before upload.
    (fn [props]
      [:div.p-2
       [:div.upload-zone.mb-4
        {:on-drag-over (fn [e]
                         (.preventDefault e)
                         (.stopPropagation e)
                         (reset! drop-active? true))
         :on-drag-leave (fn [_e]
                          (reset! drop-active? false))
         :on-drop (fn [e]
                    (.preventDefault e)
                    (select-files (filelist->vec (.. e -dataTransfer -files))))
         :class [(when @drop-active?
                   "upload-zone-active")]
         :on-click (fn [_e]
                     (.click (.-current input-ref)))}
        [:input
         {:ref input-ref
          :type "file"
          :style {:display "none"}
          ;; Value needs to be empty, so selecting same file again triggers on-change.
          :value nil
          :on-change (fn [e]
                       (select-files (filelist->vec (.. e -target -files))))}]
        (when-let [files @(qpe-subscribe [:qpe/data :controller-ui :new-project :files])]
          [:div.mb-4
           "Selected files:"
           [:ul.m-0
            (for [file files]
              [:li
               {:key (.-name file)}
               (.-name file)])]])
        "Drop a file or click to select a file"]

       [select-binary-log-mode props]

       [:div.form-group.d-flex.flex-row.justify-content-between
        [:button.btn.btn-outline-primary
         {:on-click #(do (qpe-dispatch [:project-ui/open-license-dialog false])
                         (qpe-dispatch [:qpe/close-sidebar]))}
         "Cancel"]

        [:button.btn.btn-primary
         {:on-click #(qpe-dispatch [:qpe/upload-project])}
         "Upload project"]]])))

(defn start-simulation [{:keys [qpe-dispatch qpe-subscribe]}]
  [:div.p-2
   [:p "In Simulator mode, Quuppa Site Planner is in control of QPE and will upload the project at the beginning of the simulation"]
   [:div.form-group
    [:label.lead.mt-2
     [:input.mr-2
      {:type "checkbox"
       :checked @(qpe-subscribe [:qpe/data :controller-state :simulator-mode?])
       :on-change #(qpe-dispatch [:qpe/controller-set-simulator-mode (.. % -target -checked)])}]
     "Enable simulator mode"]]])

(defn select-project [{:keys [qpe-dispatch qpe-subscribe features] :as props}]
  (let [current-project @(qpe-subscribe [:current-project/info])
        controller-state @(qpe-subscribe [:qpe/controller-state])
        controller-ui @(qpe-subscribe [:controller-ui/state-flags])
        project-ui @(qpe-subscribe [:project-ui/state])
        selected-tab (or (:selected-project-select-dialog-tab project-ui) :existing)

        ;; Close modal on Esc
        key-handler (react/useCallback (fn [e]
                                         (case (.-code e)
                                           "Escape" (qpe-dispatch [:qpe/close-sidebar])
                                           nil))
                                       #js [])]
    (react/useEffect (fn []
                       (.addEventListener js/window "keydown" key-handler)
                       (fn []
                         (.removeEventListener js/window "keydown" key-handler)))
                     #js [key-handler])

    ;; TODO: Use modal component, or rewrite otherwise.
    [:div.d-flex.flex-row
     [:div.modal-backdrop.fade.show]
     [:div.modal.fade.show.d-block
      {:tab-index "-1"
       ;; Close modal if clicking outside of the modal window
       :on-click (fn [_e]
                   (qpe-dispatch [:qpe/close-sidebar]))}
      [:div.modal-dialog.modal-dialog-scrollable.modal-xl
       {:on-click (fn [e]
                    (.stopPropagation e))}
       [:div.modal-content
        [:<>
         [:div.modal-header.align-items-center.px-4
          [:h4.modal-title "Project details"]
          [button/close-button
           {:on-click #(qpe-dispatch [:qpe/close-sidebar])}]]
         [:div.modal-body
          {:style {:white-space "pre-wrap"}}
          (if (:license-key controller-state)
            [:div.p-2
             [:dl.m-0
              [:dt "License key"]
              [:dd
               [:span (:license-key controller-state)]]

              [:dt "Project Name"]
              [:dd (:project-name current-project)]

              [:dt "Project Notes"]
              [:dd (or (not-empty (:notes current-project)) "-")]]]

            [:div.p-4.bg-info "No project is currently selected"])

          (if (:req-change-project controller-ui)
            [:div.d-flex.align-items-center.p-4.flex-column
             [:span.lead
              "Changing project, please wait..."]
             [spinner]]

            [:div
             [:div.px-2.mb-2
              [:h4 "Choose a different project"]]
             [:div.nav.nav-tabs
              (doall
                (for [tab (keep identity
                                [{:id :existing :label [:span.mx-2 "Select previous"]}
                                 {:id :key :label [:span.mx-2 "Set new key"]}
                                 ;; If features map is given (QSM) check if feature is enabled.
                                 (when (or (nil? features)
                                           (get features :upload-project false))
                                   {:id :upload :label [:span.mx-2 "Upload new project"]})
                                 {:id :simulator :label [:span.mx-2 "Run a simulation"]}])]
                  [:li.nav-item
                   {:key (:id tab)}
                   [:a.nav-link
                    {:href "#"
                     :on-click (fn [e]
                                 (.preventDefault e)
                                 (qpe-dispatch [:project-ui/select-project-select-dialog-tab (:id tab)]))
                     :class (when (= (:id tab) selected-tab) "active")}
                    (:label tab)]]))]

             (case selected-tab
               :existing [select-existing-project props]
               :key [select-project-key props]
               :upload [upload-project props]
               :simulator [start-simulation props]
               nil)])]]]]]]))

(defn date-time-field
  "Displays date-time in a :span element, including 'timeago' string relative from now.
  Example output string: 2022-06-29 09:48:52 (UTC+00:00) (15 minutes ago)

  Opts pare passed to the containing :span element."
  ([ts] (date-time-field {} ts))
  ([opts ts]
   (when ts
     ;; old QPE-next uses formatted strings
     (if (string? ts)
       ts
       (if (instance? Temporal ts)
         [:span
          opts
          (date-time/format-date-time ts)
          " "
          [timeago/timeago-2
           {:value     (date-time/temporal->native-date ts)
            :format-fn (fn [val] (str "(" (date-time/duration-string val) ")"))}]]
         [:span.text-danger {:title (str ts)} "Invalid format"])))))

(defn run-mode-titles
  "Returns tuple of [title subtitle]."
  [controller-state]
  (case (:pe-run-mode controller-state)
    :WaitingForQSP ["Simulation"
                    "Waiting for Site Planner data"]
    :Stopped ["Idle" nil]
    :Error [[:<> "Error: " (:pe-error controller-state)]
            nil]
    ;; FIXME: What is this case?
    :WaitingForPortal ["Waiting for Portal" nil]
    :InvalidQSPVersion ["Invalid QSP Version" nil]
    :Tracking [(cond
                 (:simulator-mode? controller-state) "Simulation"
                 (:binary-log-mode? controller-state) "Binary log reading"
                 :else "Tracking")
               [:<> "Started " [date-time-field (:pe-start-timestamp controller-state)]]]
    :Deployment ["Deployment"
                 [:<> "Started " [date-time-field (:pe-start-timestamp controller-state)]]]
    ["Unknown" nil]))

(defn table-header [text]
  [:tr.table-header-row
   [:th
    {:col-span "2" :scope "col"}
    [:h4.my-1 text]]])

(defn pe-mode-buttons [simulator-mode? pe-running? qpe-dispatch]
  (when-not simulator-mode?
    (if pe-running?
      [:button.py-0.btn.btn-primary
       {:on-click #(qpe-dispatch [:qpe/run :stop])}
       "Stop"]
      [:div.mx-n1
       [:button.py-0.mx-1.btn.btn-primary
        {:on-click #(qpe-dispatch [:qpe/run :normal])}
        "Start in tracking mode"]
       [:button.py-0.mx-1.btn.btn-primary
        {:on-click #(qpe-dispatch [:qpe/run :deployment])}
        "Start in deployment mode"]])))

(defn license-expiration-date [pe-running? current-project project-license qpe-dispatch]
  [:tr
   [:th
    {:scope "row"}
    "License Expiration date:"
    [info-button "The expiration date of the License this PE is set to use"]]
   [:td.no-icon
    [:div.d-flex.flex-row.align-items-center
     [:span.mr-1.flex-grow-1
      (cond
        (not pe-running?) "-"
        (not current-project) "-"
        :else
        (if project-license
          (cond
            (nil? (:expirationDate project-license)) "-"
            (:isPerpetual project-license) "Perpetual license"
            :else
            [date-time-field  (:expirationDate project-license)])
          "-"))]
     [:button.btn.btn-primary.py-0
      {:on-click #(qpe-dispatch [:qpe/toggle-sidebar {:type :license-details}])}
      "View License Details"]]]])

(defn quuppa-project [controller-state qpe-dispatch]
  (let [project-name (:project-name controller-state)
        project-version (:project-version controller-state)
        simulator-mode? (:simulator-mode? controller-state)
        license-key (:license-key controller-state)
        quuppa-project-class-name (cond
                                    simulator-mode?
                                    "text-info"

                                    (:binary-log-mode? controller-state)
                                    "text-info"

                                    license-key
                                    "text-success"

                                    :else
                                    "text-warning")]
  [:tr
   ;; Just one column has the width set, but that is enough. Just note that if you remove this row,
   ;; width should be set on some other row.
   [:th.w-25
    "Quuppa Project:"
    [info-button "Quuppa Project this QPE instance is currently running"]]
   [:td
    [:div.d-flex.flex-row.align-items-center
     [:div.qi-circle.mr-3
      {:class quuppa-project-class-name}]

     ;; Don't render margins if e.g. in simulator mode without project.
     ;; Icons and button need align-center, different text sizes
     ;; need align baseline to match visually.
     [:div.d-flex.flex-row.align-items-baseline
      (when project-name
        [:span.lead.mr-3 project-name])
      (when project-version
        [:span.lead.mr-3 project-version])

      (cond
        simulator-mode?
        [:span "Simulator mode"]

        (:binary-log-mode? controller-state)
        [:span "Binary log mode"]

        license-key
        [:span "Key is set"])]

     [:div.flex-grow-1]

     (if simulator-mode?
       [:button.py-0.btn.btn-primary
        {:on-click #(qpe-dispatch [:qpe/controller-set-simulator-mode false])}
        "End simulation"]
       [:button.py-0.btn.btn-primary
        {:on-click #(qpe-dispatch [:qpe/toggle-sidebar {:type :select-project-modal}])}
        "Change Project"])]]]))

(defn qpe-mode [qpe-subscribe controller-state qpe-dispatch]
  (let [controller-ui @(qpe-subscribe [:controller-ui/state-flags])
        license-key (:license-key controller-state)
        simulator-mode? (:simulator-mode? controller-state)
        pe-running? (:pe-running? controller-state) ]

  [:tr
   [:th {:scope "row"} "QPE Mode:"
    [info-button [:div "Running Mode of the QPE."
                  [:p "Deployment Mode is used when deploying the Quuppa system."]
                  [:p "Tracking Mode is used when tracking the Tags."]]]]
   (if (:req-run controller-ui)
     [:td.no-icon
      [:div.inline-block
       [spinner]]]
     ; If no license and not in simulator mode, show no stopped badge and buttons
     (if (or license-key
             simulator-mode?
             ;; No need to check other than this?
             pe-running?)
       [:td
        [:div.d-flex.flex-row.align-items-center
         [:div.qi-circle.mr-3
          {:class (cond
                    simulator-mode? "text-danger"
                    pe-running? "text-success"
                    (nil? (:pe-run-mode controller-state)) "text-warning"
                    (= (:pe-run-mode controller-state) :Error) "text-danger"
                    :else nil)}]

         [:span.flex-grow-1
          (let [[title subtitle] (run-mode-titles controller-state)]
            (if subtitle
              [:<> title ": " subtitle]
              title))]

         [pe-mode-buttons simulator-mode? pe-running? qpe-dispatch]]]
       [:td.no-icon.d-flex.justify-content-between.align-items-center
        [:span.badge.bg-danger "Stopped, no project"]
        [:div
         [pe-mode-buttons simulator-mode? pe-running? qpe-dispatch]]]))]))

(defn project-license-sync-status [controller-state qpe-dispatch qpe-subscribe]
  [:tr
   [:th {:scope "row"} "Project and License Sync Status:"
    [info-button "Status of Project and License Synchronization from Quuppa Portal."]]
   (if (:simulator-mode? controller-state)
     [:td.no-icon "[Simulator mode]"]
     [:td
      [:div.d-flex.flex-row.align-items-center
       [:div.qi-circle.mr-3
        {:class (case (:file-sync-status controller-state)
                  ; FIXME note that for offline projects, we shouldn't necessarily display error
                  ; with danger, see QuuppaServerController.getFileSyncStatusString
                  :Error "text-danger"
                  :NotRunning "text-secondary"
                  :Ok "text-success"
                  :Running "text-info"
                  :Error_Non_Operational "text-warning"
                  "text-warning")}]

       [:span.flex-grow-1
        (case (:file-sync-status controller-state)
          ; FIXME note that for offline projects, we shouldn't necessarily display error
          ; with danger, see QuuppaServerController.getFileSyncStatusString
          :Error (:last-file-sync-error controller-state)
          :NotRunning "Not running"
          :Ok "Ok"
          :Running "Running"
          :Error_Non_Operational "Running"
          "<unknown state>")]

       [:button.ml-1.py-0.btn.btn-primary
        {:on-click #(qpe-dispatch [:qpe/force-file-sync])
         :disabled @(qpe-subscribe [:controller-ui/file-sync-control-disabled?])}
        "Do File Sync"]]])])

(defn peinfo-software [{:keys [qpe-subscribe qpe-dispatch] :as _props}]
  (let [controller-state @(qpe-subscribe [:qpe/controller-state])
        current-project @(qpe-subscribe [:current-project/info])
        project-license @(qpe-subscribe [:current-project/license])
        simulator-mode? (:simulator-mode? controller-state)
        pe-running? (:pe-running? controller-state)]
    [:tbody
     [table-header "Software"]

     [quuppa-project controller-state qpe-dispatch]
     [license-expiration-date pe-running? current-project project-license qpe-dispatch]

     [qpe-mode qpe-subscribe controller-state qpe-dispatch]

     [:tr
      [:th {:scope "row"} "QPE Version:"
       [info-button "Software version of this QPE."]]
      [:td.no-icon (:pe-version controller-state)]]
     [:tr
      [:th {:scope "row"} "Working Directory:"]
      [:td.no-icon (:project-folder controller-state)]]

     [project-license-sync-status controller-state qpe-dispatch qpe-subscribe]

     (when-not simulator-mode?
       [:<>
        [:tr
         [:th {:scope "row"} "Last Synchronized at:"
          [info-button "Project and License were last synchronized at this time."]]
         [:td.no-icon
          [date-time-field (:last-sync-status controller-state)]]]]
       [:tr
        [:th {:scope "row"} "Next Scheduled Sync Time:"
         [info-button "Project and license Synchronization will be tried at this time."]]
        [:td.no-icon
         (if (and current-project
                  (false? (:connect-to-qcp controller-state)))
           [:span.note "Automatic filesyncs and status uploads to QCP disabled"]
           [date-time-field (:next-scheduled-sync controller-state)])]]
       [:tr
        [:th {:scope "row"} "Local Synced Files Valid Until:"
         [info-button "If connectivity to the Quuppa Portal is lost
                      the Positioning Engine will stop working at this time."]]
        [:td.no-icon
         [date-time-field (:files-invalid-after controller-state)]]])
     [:tr
      [:th {:scope "row"} "Location Based Commands:"
       [info-button [:div "Status of Location Based Commands in the Project."
                     [:p "The LBS commands may be disabled e.g. when no interesting
                         activity is happening on sport event. This may improve
                         the Tag battery lifetime considerably."]]]]
      [:td.no-icon
       (case (:activation-status current-project)
         :not-available
         [:span "-"]

         :not-configured
         [:span "Not configured"]

         (:enabled :disabled)
         [:div.btn-group
          [:button.btn.btn-outline-primary.btn-sm
           {:on-click #(qpe-dispatch [:qpe/enable-location-based-commands :enabled])
            :class    (when (= :enabled (:activation-status current-project)) "active")}
           "Enabled"]
          [:button.btn.btn-outline-primary.btn-sm
           {:on-click #(qpe-dispatch [:qpe/enable-location-based-commands :disabled])
            :class    (when (= :disabled (:activation-status current-project)) "active")}
           "Disabled"]]

         nil)]]]))

(defn platform-status [value]
  (when value
    ;; this map check is for older version of QPE. Before these changes `platform-status` came as string
    (if (map? value)
      (let [{:keys [disk-free system-cpu-load memory-total process-cpu-load memory-max memory-used memory-free
                    jvm-version memory-used-percentage]} value]
        [:div
         (when memory-total
           [:div [:span.text-secondary "Total memory: "]
            [:span (format-bytes memory-total)]])
         (when memory-max
           [:div [:span.text-secondary "Max memory: "]
            [:span (format-bytes memory-max)]])
         (when memory-used
           [:div [:span.text-secondary "Used memory: "]
            [:span (format-bytes memory-used)]])
         (when memory-free
           [:div [:span.text-secondary "Free memory: "]
            [:span (format-bytes memory-free)]])
         (when memory-used-percentage
           [:div [:span.text-secondary "Memory used: "]
            [:span {:class (cond
                             (> memory-used-percentage 70) "text-warning"
                             (> memory-used-percentage 85) "text-danger")}
             memory-used-percentage "%"]])
         (when disk-free
           [:div [:span.text-secondary "Disk Free: "]
            [:span {:class (cond
                             (< disk-free (* 5 1024 1024 1024)) "text-warning"
                             (< disk-free (* 1024 1024 1024)) "text-danger")}
             (format-bytes disk-free)]])
         (when memory-used-percentage
           [:div [:span.text-secondary "System CPU load: "]
            [:span {:class (cond
                             (> memory-used-percentage 70) "text-warning"
                             (> memory-used-percentage 85) "text-danger")}
             (utils/str-format "%.2f" (double system-cpu-load))]])
         (when process-cpu-load
           [:div [:span.text-secondary "Process CPU load: "]
            [:span {:class (cond
                             (> process-cpu-load 70) "text-warning"
                             (> process-cpu-load 85) "text-danger")}
             (utils/str-format "%.2f" (double process-cpu-load))]])
         (when jvm-version
           [:div [:span.text-secondary "JVM Version: "]
            [:span jvm-version]])])
      value)))

(defn qpe-loss-rate [controller-state]
  [:<>
   (when-let [level-short (:pe-stress-level-short controller-state)]
     [:span {:class (cond
                      (> level-short 20) "text-warning"
                      (> level-short 4) "text-info")}
      (str (gstring/format "%.1f" level-short) "% ")])
   (when-let [level-long (:pe-stress-level-long controller-state)]
     [:span {:class (cond
                      (> level-long 20) "text-warning"
                      (> level-long 4) "text-info")}
      (str "(" (gstring/format "%.1f" level-long) "%) ")])])

(defn network-loss-rate [controller-state]
  [:<> (when-let [level-short (:net-stress-level-short controller-state)]
         [:span {:class (cond
                          (> level-short 10) "text-warning"
                          (> level-short 1) "text-info")}
          (str (gstring/format "%.1f" level-short) "% ")])
   (when-let [level-long (:net-stress-level-long controller-state)]
     [:span {:class (cond
                      (> level-long 10) "text-warning"
                      (> level-long 1) "text-info")}
      (str "(" (gstring/format "%.1f" level-long) "%) ")])])

(defn peinfo-hardware [{:keys [qpe-subscribe select-peinfo-tab]}]
  (let [controller-state @(qpe-subscribe [:qpe/controller-state])
        clocks-delta (:clocks-delta controller-state)
        app-id @(rf/subscribe [:app-id])
        position-events @(qpe-subscribe [:qpe/position-events])
        project-state @(qpe-subscribe [:current-project/state])
        ; locator-status is of form [ [x y] message]
        locator-status @(qpe-subscribe [:current-project/locator-status])
        locator-channels @(qpe-subscribe [:current-project/locator-channels])]
    [:tbody
     [table-header "Hardware"]
     [:tr
      [:th.w-25 {:scope "row"} "Locators Online:"
       [info-button "Number of connected Locators versus the number of Locators in the Project."]]
      [:td.no-icon
       [:div.d-flex.flex-row.align-items-center
        [:span.flex-grow-1
         {:class "note"}
         (str/join locator-status)]
        [:a.py-0.btn.btn-primary
         {:href (select-peinfo-tab {:route :qpe-info-locators})}
         "Locator Details..."]]]]
     [:tr
      [:th {:scope "row"} "Locator Uptime (minimum/median):"
       [info-button "Minimum and median uptimes of Locators.
                          Locators that have not been seen within last minute are excluded."]]
      [:td.no-icon (:locator-uptime controller-state)]]
     [:tr
      [:th {:scope "row"} "Locator Operation Mode:"
       [info-button "Operation Mode of Locators Connected to the System. (BLE or Proprietary)"]]
      [:td.no-icon locator-channels]]
     [:tr
      [:th {:scope "row"} "Tags Online:"
       [info-button "Number of visible Tags during the last 60 seconds."]]
      [:td.no-icon
       [:div.d-flex.flex-row.align-items-center
        [:span.flex-grow-1
         (:tag-online-count project-state)
         (when (> (:low-battery-tag-count project-state) 0)
           (str " (" (:low-battery-tag-count project-state) " with low battery)"))]

        [:a.btn.btn-primary.py-0
         {:href (select-peinfo-tab {:route :qpe-info-tags})}
         "Tag Details..."]]]]
     [:tr
      [:th {:scope "row"} "Platform Status:"
       [info-button
        [:span "Memory, Disk Space, and CPU status of the Platform."
         [:p "Configured memory is the value that was configured to JVM "]
         [:p "with eg. -Xmx2048m flag. Allocated is amount of memory "]
         [:p "allocated by JVM. Used is memory currently in use by JVM "]
         [:p "and free is memory that is available for JVM to use."]]]]
      [:td.no-icon
       [platform-status (:platform-status controller-state)]]]
     [:tr
      [:th {:scope "row"} "Platform Data Rates:"
       [info-button
        [:span "Network Data Rates of the Platform."
         [:p " UDP RX is the Data Rate coming from the locators to the QPE. "]
         [:p "UDP TX is the Data Rate going out of the QPE. "]
         [:p "Consist mainly from active UPD streaming."]]]]
      [:td.no-icon
       [:div
        [:div (:platform-data-rates controller-state)]
        (when position-events
          [:div (str
                  (if (= app-id :qsm)
                    "Received position events: "
                    "Computed position events: ")
                  (-> position-events :event-reception-rate)
                  "/s")])]]]
     [:tr
      [:th {:scope "row"} "QPE Loss Rate:"
       [info-button "Percentage of packets from Locators that the system didn't have time to process.
                    First value instant, average in parentheses."]]
      [:td.no-icon
       [qpe-loss-rate controller-state]]]
     [:tr
      [:th {:scope "row"} "Network Loss Rate:"
       [info-button "Percentage of packets that were lost between Locators and QPE.
                    First value instant, average in parentheses."]]
      [:td.no-icon
       [network-loss-rate controller-state]]]
     [:tr
      [:th {:scope "row"} "Network Interface Status:"
       [info-button "Status of the Network Interface connected to the Locators."]]
      [:td {:class (when (:qpe-running-in-docker controller-state) "no-icon")}
       (cond
         (not (:pe-running? controller-state)) "-"
         (empty? (:subnet-statuses controller-state)) "-"
         :else
         (if (:qpe-running-in-docker controller-state)
           [:span "Running in Docker container - configure network at host level!"]
           [:div
            (for [[k v] (:subnet-statuses controller-state)]
              [:div
               {:key k}
               (case v
                 :Up [:span [:div.qi-circle.mr-3.text-success] (name v) " " k]
                 :Down [:span [:div.qi-circle.mr-3.text-danger] (name v) " " k]
                 :NoInterface [:span [:div.qi-circle.mr-3.text-info] (name v) " " k]
                 :Error [:span [:div.qi-circle.mr-3.text-danger] (name v) " " k])])]))]]
     ;; Hidden: https://app.shortcut.com/quuppa/story/17700/displaying-time-using-time-zones
     ; [:tr
     ;  [:th {:scope "row"} "Machine timezone:"
     ;   [info-button :info "The timezone of this machine."]]
     ;  [:td.no-icon [:span (:timezone controller-state)]]]
     ; [:tr
     ;  [:th {:scope "row"} "Platform Clock:"
     ;   [info-button :info "The local clock of this machine, displayed in user's local time format."]]
     ;  [:td.no-icon [:span (date-time/format-date-time (:timestamp controller-state))]]]
     [:tr
      [:th {:scope "row"} [:span "Customer Portal Clock Delta (sec):"]
       [info-button
        [:span
         [:p "The local clock must be synced within 1 minute to the Customer Portal clock,
        otherwise this QPE wont be able to synchronize project and license."]
         [:p "Please make sure that you have NTP service configured."]]]]
      [:td.no-icon (if (nil? clocks-delta) "--" (quot clocks-delta 1000))]]]))

(defn incorrect-files-count? [upload-files]
  (< (count upload-files) 2))

(defn valid-files-names? [files]
  (let [cert-files (->> files
                        (filter (fn [file]
                                  (str/ends-with? (:file-name file) ".crt"))))
        key-files (->> files
                       (filter (fn [file]
                                 (str/ends-with? (:file-name file) ".key"))))]
        (and (= 1 (count cert-files))
             (= 1 (count key-files)))))

(def create-universal-target-form-validated? (r/atom false))
(def control-universal-target-form-validated? (r/atom false))

(defn create-universal-target [{:keys [qpe-subscribe qpe-dispatch] :as props} qpe]
  (let [{:keys [title target]} @(qpe-subscribe [:qpe/data :ui :sidebar :settings])
        pending? @(qpe-subscribe [:qpe/data :ui :sidebar :pending?])
        ut @(qpe-subscribe [:qpe/data :ui :sidebar :ut])
        mqtt-certificates? (and (= (:target ut) "mqtt")
                                (some #{(:MQTTScheme ut)} ["ssl/tls" "wss"]))
        disabled-save-button? (or (and mqtt-certificates?
                                       (= "client" (:certificate-validation ut))
                                       (incorrect-files-count? (:files ut))
                                       (not (valid-files-names? (:files ut))))
                                  pending?)]
    [layout/sidebar
     [layout/sidebar-header
      {:title    (gstring/format "New %s Configuration" title)
       :on-close (fn []
                   (reset! create-universal-target-form-validated? false)
                   (qpe-dispatch [:qpe/close-sidebar])
                   (qpe-dispatch [:qsm/clear-siteresources]))}]

     [layout/sidebar-content
      [form/form {:noValidate true
                  :validated  @create-universal-target-form-validated?
                  :onSubmit   (fn [e]
                                (.preventDefault e)
                                (let [form (.-currentTarget e)]
                                  (when (not (.checkValidity form))
                                    (.stopPropagation e))
                                  (reset! create-universal-target-form-validated? true)
                                  (when (.checkValidity form)
                                    (qpe-dispatch [:qpe/create-universal-target (dissoc ut :title :description)]))))}

       ^{:key (or (:id ut) (:new-target-key ut))}
      [peweb-ut/universal-target-form target ut (assoc props :form-type :create :pending? pending?) qpe create-universal-target-form-validated?]
       [:div.d-flex.justify-content-between
        [:button.btn.btn-warning
         {:type "button"
          :disabled pending?
          :on-click (fn []
                      (reset! create-universal-target-form-validated? false)  ;; <-- reset here
                      (qpe-dispatch [:qpe/close-sidebar]))}
         "Cancel"]

        [:button.btn.btn-success
         {:type     "submit"
          :disabled disabled-save-button?}
         "Create"]]]

      [c/error-alert @(qpe-subscribe [:qpe/data :ui :sidebar :error])]]]))

(defn control-universal-target [{:keys [qpe-subscribe qpe-dispatch] :as props} qpe]
  (r/with-let [_ (reset! control-universal-target-form-validated? false)]
    (let [{:keys [target title] :as _settings} @(qpe-subscribe [:qpe/data :ui :sidebar :settings])
          pending? @(qpe-subscribe [:qpe/data :ui :sidebar :pending?])
          {target-name :name :as modified} @(qpe-subscribe [:qpe/data :ui :sidebar :ut])
          ut' @(qpe-subscribe [:qpe/data :ui :sidebar :current])
          ;; Keep same mode
          modified (assoc modified :mode (if (:enabled ut') "start" "stop"))
          ;; Merge current backend value and form values for display.
          ;; Backend value might contain some extra read-only properties,
          ;; but it doesn't matter.
          ut (merge ut' modified)
          siteresource @(qpe-subscribe [:qsm/siteresource])
          site-plan-key @(qpe-subscribe [:qpe/data :current-project :license-uuid])
          no-uploaded-files-for-mqtt-certificates? (and (= (:target ut) "mqtt")
                                                        (some #{(:MQTTScheme ut)} ["ssl/tls" "wss"])
                                                        (= (:certificate-validation ut) "client")
                                                        (nil? siteresource))
          disabled-save-button? (or (and no-uploaded-files-for-mqtt-certificates?
                                         (incorrect-files-count? (:files ut))
                                         (not (valid-files-names? (:files ut))))
                                    pending?)]
      [layout/sidebar
       [layout/sidebar-header
        {:title (str "Edit " title  " configuration")
         :on-close (fn []
                     (qpe-dispatch [:qpe/close-sidebar])
                     (qpe-dispatch [:qsm/clear-siteresources]))}]

       [layout/sidebar-content
        [form/form {:noValidate true
                    :validated  @control-universal-target-form-validated?
                    :onSubmit   (fn [e]
                                  (.preventDefault e)
                                  (let [form (.-currentTarget e)]
                                    (when (not (.checkValidity form))
                                      (.stopPropagation e)))
                                  (qpe-dispatch [:qpe/control-universal-target modified]))}
         [peweb-ut/universal-target-form target ut (assoc props :form-type :control :pending? pending?) qpe]
         [c/error-alert @(qpe-subscribe [:qpe/data :ui :sidebar :error])]
         [:div.d-flex.justify-content-between
          [:button.btn.btn-warning
           {:type "button"
            :on-click (fn []
                        (qpe-dispatch [:qpe/close-sidebar])
                        (qpe-dispatch [:qsm/clear-siteresources]))}
           "Cancel"]

          [:button.btn.btn-danger
           {:type "button"
            :disabled pending?
            :on-click (fn [_e]
                        (when (js/confirm "Are you sure?")
                          (qpe-dispatch [:qpe/control-universal-target {:name target-name
                                                                        :mode "delete"
                                                                        :site-plan-key site-plan-key}])))}
           "Delete"]

          [:button.btn.btn-success
           {:type "submit"
            :disabled disabled-save-button?}
           "Save"]]]]])))

(defn peinfo-outputs-udp-target-settings
  [{:keys [qpe-dispatch qpe-subscribe]}]
  (let [settings @(qpe-subscribe [:qpe/data :ui :sidebar :settings])
        project-state @(qpe-subscribe [:qpe/project-state])]
    [layout/sidebar
     [layout/sidebar-header
      {:title "Data Player Live View settings"
       :on-close #(qpe-dispatch [:qpe/close-sidebar])}]

     [layout/sidebar-content
      [:div.mb-3
       [:label "IP:"]
       [c/input-text
        {:value (or (:ip settings)
                    (:data-udp-target-ip project-state))
         :on-change #(qpe-dispatch [:qpe/assoc-in [:ui :sidebar :settings :ip] %])}]]

      [c/error-alert (:error settings)]

      [:div.d-flex.justify-content-between
       [:button.btn.btn-warning
        {:on-click #(qpe-dispatch [:qpe/close-sidebar])}
        "Cancel"]

       [:button.btn.btn-success
        {:type "button"
         :on-click (fn [_e]
                     (qpe-dispatch [:qpe/control-output-target
                                    {:id "QuuppaDataUDP"
                                     :ip (or (:ip settings)
                                             (:data-udp-target-ip project-state))}]))}
        "Save"]]]]))

(defn peinfo-outputs [{:keys [qpe-subscribe] :as opts}]
  (let [ut-modes (or @(qpe-subscribe [:qpe/data :project-state :available-target-modes])
                     ;; TODO MQTT
                     ;; Support old clients that do not send :available-target-modes
                     [:UDP :File])]
    [:tbody
     [table-header "Outputs"]
     [:tr
      [:th {:scope "row"}
       "Data Player Recording:"
       [info-button "Status of Data Player Recording."]]
      [:td [outputs/peinfo-outputs-data-player-target opts]]]

     [:tr
      [:th {:scope "row"}
       "Data Player Live View:"
       [info-button "Status of Data Player Live View Output Streaming."]]
      [:td [outputs/peinfo-outputs-udp-target opts]]]

     (into
       [:<>]
       (for [target ut-modes
             ;; If we don't have 'ui-config' for UT, we still display it's title as is.
             ;; If at some point we want to control which targets are offered in UI, adding e.g. simple :when
             ;; clause here could be quick fix.
             :let [{:keys [description title] :as conf} (get peweb-ut/mode->ui-config target {:title (name target)})
                   show-experimental-badge? (= target :Websocket)]]
         [:tr
          [:th {:scope "row"}
           title
           (when description
             [info-button description])
           (when show-experimental-badge?
             [:span.badge.rounded-pill.bg-secondary.ml-2.text-sm "Experimental"])]
          [:td [outputs/peinfo-universal-targets (assoc conf :target target) opts]]]))

     [:tr
      [:th {:scope "row"}
       "Binary Logging:"
       [info-button "Binary Logging is used to log all system data for debugging purposes. Binary Data is readable only by Quuppa internal debugging tools."]]
      [:td
       [outputs/peinfo-binary-logging opts]]]]))

(defn peinfo-sidebar [{:keys [qpe-subscribe qpe-dispatch] :as props} qpe]
  (case @(qpe-subscribe [:qpe/data :ui :sidebar :type])
    :output-udp-target-settings [peinfo-outputs-udp-target-settings props]
    :license-details [license-details
                      @(qpe-subscribe [:current-project/license])
                      (assoc props :close-fn #(qpe-dispatch [:qpe/close-sidebar]))]
    :create-universal-target [create-universal-target props qpe]
    :control-universal-target [control-universal-target props qpe]
    :select-project-modal [:f> select-project props]
    nil))

;; TODO: compare with engine-tab component in Site view
(defn peinfo-system [{:keys [qpe-subscribe] :as props} qpe]
  [layout/section
   [layout/view-content
    {:sidebar-open @(qpe-subscribe [:qpe/data :ui :sidebar :type])}

    [:table.table.table-sm.table-striped.table-bordered.w-100.peinfo-table
     [peinfo-software props]
     [peinfo-hardware props]
     [peinfo-outputs props]]]

   [peinfo-sidebar props qpe]])

(defn peinfo-tabs-data [extra]
  (-> [{:id :system
        :route :qpe-info-system
        :label "System"
        :data-test-id "system-qpe-tab"}]
      (into extra)
      (into [{:id :locators
              :route :qpe-info-locators
              :label "Locators"
              :data-test-id "locators-qpe-tab"}
             {:id :tags
              :route :qpe-info-tags
              :label "Tags"
              :data-test-id "tags-qpe-tab"}
             {:id :log
              :route :qpe-info-log
              :label "Log"
              :data-test-id "logs-qpe-tab"}
             {:id :map
              :route :qpe-info-map
              :label "Map"
              :data-test-id "map-qpe-tab"}])))

(defn peinfo-tab
  [{:keys [selected-peinfo-tab]
    :as props} qpe]
  [c/error-boundary
   (case selected-peinfo-tab
     :system [peinfo-system props qpe]
     :locators [:f> locators/locator-grid props]
     :tags [:f> tags/tag-grid props]
     :log [peinfo-logs/qpe-details-log props]
     :map [c/lazy-component
           {:fallback [:div "Loading view"]}
           (lazy/loadable quuppa.peweb.mapview/mapcontrols)
           props])])

(defn peinfo-nav
  [{:keys [selected-peinfo-tab
           select-peinfo-tab
           extra-tabs]
    :as _props}]
  [:ul.mt-2.px-4.nav.nav-tabs.d-flex.flex-shrink-0.mx-n4
   (for [tab (peinfo-tabs-data extra-tabs)]
     [:li.nav-item
      {:key (:id tab)}
      [:a.nav-link
       {:href (select-peinfo-tab tab)
        :data-test-id (:data-test-id tab)
        :class (when (= selected-peinfo-tab (:id tab))
                 "active")}
       (:label tab)]])])

(defn peinfo-header [{:keys [qpe-subscribe qpe-dispatch] :as props} qpe]
  (let [app-id @(rf/subscribe [:app-id])
        connection-established? (case app-id
                                  :qpe @(qpe-subscribe [::connection/connection-established?])
                                  :qsm (= "online" (:status qpe)))
        alerts @(qpe-subscribe [:controller-ui/messages])
        warning-title (if (= (count alerts) 1)
                        " warning"
                        " warnings")
        on-close! (fn [alert-id]
                    (qpe-dispatch [:controller-ui/close-message alert-id]))]
    [:<>
     [:h1.d-flex.align-items-center
      (if connection-established?
        [:div.qi-circle.text-success.pl-2.mr-3
         {:title "Online"
          :style {:font-size "1rem"}}]
        [:div.qi-circle.text-danger.pl-2.mr-3
         {:title "Offline"
          :style {:font-size "1rem"}}])
      (if-let [n (or (:name qpe)
                     (:location qpe))]
        n
        "QPE")]

     [alert-popover {:alerts alerts
                     :title warning-title
                     :on-close! on-close!}]]))
